const features = [
  {
    icon: 'ri-shield-keyhole-line',
    iconBg: 'bg-cyan-50',
    iconColor: 'text-cyan-600',
    hoverIconBg: 'group-hover:bg-cyan-500',
    title: 'Bank-Level Security',
    description:
      'All our applications implement AES-256 encryption and secure key management, meeting the same standards used by financial institutions worldwide.',
  },
  {
    icon: 'ri-rocket-2-line',
    iconBg: 'bg-emerald-50',
    iconColor: 'text-emerald-600',
    hoverIconBg: 'group-hover:bg-emerald-500',
    title: 'Lightning Performance',
    description:
      'Optimized for iOS hardware, our apps run with minimal CPU and memory footprint — so your device stays fast and your battery lasts longer.',
  },
  {
    icon: 'ri-eye-off-line',
    iconBg: 'bg-violet-50',
    iconColor: 'text-violet-600',
    hoverIconBg: 'group-hover:bg-violet-500',
    title: 'Complete Privacy',
    description:
      'We operate a strict no-tracking, no-log policy. Your usage data is never collected, sold, or shared with any third party — ever.',
  },
  {
    icon: 'ri-smartphone-line',
    iconBg: 'bg-orange-50',
    iconColor: 'text-orange-600',
    hoverIconBg: 'group-hover:bg-orange-500',
    title: 'Native iOS Design',
    description:
      'Built following Apple\'s Human Interface Guidelines, our apps feel right at home on any iPhone — intuitive, accessible, and beautifully crafted.',
  },
  {
    icon: 'ri-refresh-line',
    iconBg: 'bg-teal-50',
    iconColor: 'text-teal-600',
    hoverIconBg: 'group-hover:bg-teal-500',
    title: 'Regular Updates',
    description:
      'We continuously improve our products with new features, security patches, and iOS compatibility updates — keeping you ahead of the curve.',
  },
  {
    icon: 'ri-customer-service-2-line',
    iconBg: 'bg-rose-50',
    iconColor: 'text-rose-600',
    hoverIconBg: 'group-hover:bg-rose-500',
    title: '24/7 Expert Support',
    description:
      'Our dedicated support team is available around the clock to help with any questions, issues, or feedback you may have about our products.',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-24 md:py-32 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 border border-slate-200 rounded-full px-4 py-1.5 mb-5">
            <span className="text-slate-500 text-xs font-semibold tracking-widest uppercase">Why Choose Us</span>
          </div>
          <h2
            className="text-4xl md:text-5xl font-bold text-slate-900 mb-4"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Advanced Features for
            <br />
            <span className="text-cyan-500">Enhanced Mobile Experience</span>
          </h2>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto">
            Every feature we build is driven by a commitment to security, performance, and user satisfaction — no compromises.
          </p>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f) => (
            <div
              key={f.title}
              className="group bg-white rounded-2xl p-6 md:p-8 border border-slate-100 hover:bg-slate-900 transition-all duration-300 cursor-default"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${f.iconBg} ${f.hoverIconBg} transition-colors duration-300 mb-5`}>
                <i className={`${f.icon} ${f.iconColor} group-hover:text-white text-xl transition-colors duration-300`}></i>
              </div>
              <h3
                className="text-lg font-bold text-slate-900 group-hover:text-white mb-3 transition-colors duration-300"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {f.title}
              </h3>
              <p className="text-sm text-slate-500 group-hover:text-slate-300 leading-relaxed transition-colors duration-300">
                {f.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
